import forEach from 'lodash/forEach';

import ReSourceAPI, { EsnapsAPI } from '../../utils/api';
import {createStore} from '../../utils/store';

import {
    ExperienceSampling,
    Questionnaire,
    Medium,
    User,
    Esnap,
} from './actions';

import reducer from './reducer';

const ReadOnlyAPI = new ReSourceAPI(null);
const EsnapAPI = new EsnapsAPI(null);

const prepare = ({api = ReadOnlyAPI, rootReducer = reducer, initialState = null, history, ownMiddlewares, name}) => {
    const store = createStore(rootReducer, {api, ...initialState}, history, ownMiddlewares, name);

    const fetches = {
        [ExperienceSampling.update]: api.samplings,
        [Questionnaire.update]: api.questionnaire,
        [User.update]: api.user,
        [Medium.update]: api.media,
        [Esnap.update]: EsnapAPI.activeEsnaps
    };

    forEach(fetches, (endpoint, type) => {
        endpoint.list().then(payload => store.dispatch({type, payload}));
    });

    return store;
};

export default prepare;



// WEBPACK FOOTER //
// ./scripts/frontend/base/prepare.js